// Temporary containment for home-feed responses mixing device variants.
// Verified against Apollo Feeds V3 on 2026-09-20. Only exact known assets
// match: replacing campaign artwork in Apollo automatically escapes this map.
const image = (hash) => ({
  kind: 'image',
  url: `https://cdn.pomelofashion.com/img/iosfeeds/images/${hash}.jpeg`,
})
const video = (hash, poster) => ({
  kind: 'video',
  url: `https://cdn.pomelofashion.com/img/iosfeeds/videos/${hash}.mp4`,
  ...(poster && { thumbnail_url: image(poster).url }),
})

export const verifiedBannerMedia = {
  8445: {
    desktop: video(
      '114650429ca2c5acfc745d0b3ff3ec02',
      '3ca2caca15626050e9433209bed70c4c',
    ),
    phone: video(
      '700a1be59d1ec0f9dc64ad88c33a5ab0',
      '87fdd2564c6e6b334d9c6a07455fe89b',
    ),
  },
  8456: {
    desktop: image('9190f28ee887b22bc7aed1dd6529278f'),
    phone: image('b9c01d587650fd29f9dcb167c737804b'),
  },
  8428: {
    desktop: image('06f676f7d66b6636af86e3ad28effd7c'),
    phone: image('1a17dbaf15a743574d93791e9052db43'),
  },
  8424: {
    desktop: image('0524e7313044542a8348a633e2169831'),
    phone: video('a885945c89e84c7381bc3ef09db1a785'),
  },
  8427: {
    desktop: image('4e34eb59482392b8259a5ba505a69611'),
    phone: image('e460ddc77b2ecde84f9c4e6c97b1c702'),
  },
}

const assetPath = (url) => {
  try {
    const parsed = new URL(url)
    if (
      !['cdn.pomelofashion.com', 'pomelo-s3-media.pomelofashion.com'].includes(
        parsed.hostname,
      )
    )
      return null
    return parsed.pathname
  } catch (_) {
    return null
  }
}

export default function resolveBannerMedia(banner, isPhone) {
  const current = banner?.attributes?.media
  const pair = verifiedBannerMedia[banner?.id]
  const path = assetPath(current?.url)
  if (
    !pair ||
    !path ||
    !Object.values(pair).some((media) => assetPath(media.url) === path)
  )
    return current
  return pair[isPhone ? 'phone' : 'desktop']
}
